import React from 'react';
import {Menu, MenuTargetProps} from '@mantine/core';

export const EtroMenuTarget: React.FC<MenuTargetProps> = ({
  children,
  ...rest
}) => {
  return <Menu.Target {...rest}>{children}</Menu.Target>;
};
